module.exports = __webpack_public_path__ + "img/bg-seo-categorie.3cc1b47.jpg";